/**
 * Returns Tailwind classes for role badge styling.
 * @param {string} role - user role (admin, manager, user).
 * @returns {string} Tailwind classes for the badge.
 */
export const getRoleBadgeClasses = (role) => {
  switch (role) {
    case 'admin':
      return 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300';
    case 'manager':
      return 'bg-amber-100 dark:bg-amber-900/30 text-amber-800 dark:text-amber-300';
    default:
      return 'bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-slate-200';
  }
};

/**
 * Generates initials from a full name.
 * @param {string} name - full name (e.g., "John Doe").
 * @returns {string} initials (e.g., "JD").
 */
export const getInitials = (name) => {
    if (!name) return 'U';
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
        return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
    }
    return parts[0].charAt(0).toUpperCase();
};
